import React from "react";
import { connect } from "react-redux";
import { Route as SimpleRoute, Redirect } from "react-router-dom";
import { selectors as userSelectors } from "../redux/user";
import { selectors as brandSelectors } from "../redux/brand";
import {
  actions as routerActions,
  selectors as routerSelectors
} from "../redux/router";
import {
  actions as storageActions,
  selectors as storageSelectors
} from "../redux/storage";
import { actions as modalActions } from "../redux/modals";
import { alohomoraRedirectURL } from "../redux/router/utils";
import { homeRedirect } from "../ui/utils/home-redirect";

/**
 * Handles redirects of authentication, sso, account completion, blah blah blah
 */
class Route extends React.Component {
  redirectToAlohomora() {
    const { brand, currentRoute, location } = this.props;

    window.location = alohomoraRedirectURL(
      brand.Alohomora.host,
      location,
      currentRoute
    );

    // seems that returning null causes some sort of re-render, just return empty span
    return <span />;
  }

  // checks SSO settings and if the user needs to finish their account
  // Need to add logic around how this is remembered and when and why
  checkSSO() {
    // do not run for /home/eula /terms /user
    const { userInfo, brand, skipSSO, hasSkippedSSO } = this.props;
    const isSSOUser = userInfo && userInfo.ssoOnly;
    return (
      !brand.Alohomora.enabled &&
      !skipSSO &&
      isSSOUser &&
      (brand.AccountCompletion.force ||
        // TODO less than ideal that we have to check ssoSkipped in Fraction.Helpers here
        // eventually we can get off of it....
        (!Fraction.Helpers.ssoSkipped &&
          brand.AccountCompletion.enabled &&
          !brand.AccountCompletion.ssoOnly &&
          !hasSkippedSSO))
    );
  }

  verifyEmail() {
    const { skipVerifyEmail, brand, userInfo } = this.props;

    return (
      !skipVerifyEmail &&
      brand.EmailVerification.enabled &&
      userInfo.emailVerificationRequired &&
      !userInfo.emailVerificationCompleted
    );
  }

  redirect = destination => {
    const { currentRoute, brand } = this.props;
    // These urls will handle redirecting to themselves, ignore them.
    const denylist = [
      "#/user/complete",
      "#/user/decide",
      "#/user/edit",
      "#/user/sso",
      "#/terms",
      "#/user/eula",
      "#/user/terms",
      "#/user/update-password",
      "#/user/signin",
      "#/verify"
    ];
    if (denylist.indexOf(currentRoute.hash) === -1) {
      if (brand.Alohomora.enabled) {
        return this.redirectToAlohomora();
      } else {
        if (currentRoute.hash !== "#/") {
          Fraction.Helpers.clearRedirect();
          this.props.setStoredRedirect(currentRoute);
        }
      }
    }
    return <Redirect to={`${destination}${currentRoute.search}`} />;
  };

  getComponent = componentProps => {
    const {
      path,
      brand,
      alohomoraRoute,
      skipAll,
      authenticated,
      component: Component,
      clearStoredRedirect,
      skipRedirect,
      storedRedirect,
      shouldShowOnboarding,
      setHasSeenWelcomeOnboarding
    } = this.props;
    if (alohomoraRoute && brand.Alohomora.enabled) {
      return this.redirectToAlohomora();
    }
    if (skipAll) {
      return <Component {...componentProps} />;
    }
    if (authenticated) {
      if (this.verifyEmail()) {
        return this.redirect("/verify");
      }
      if (this.checkSSO()) {
        return this.redirect("/user/sso");
      }
      if (!skipRedirect && storedRedirect) {
        clearStoredRedirect();
        // TODO I really wish we didn't have the other stored redirect stuff but might as well clear it....
        Fraction.Helpers.clearRedirect();
        return <Redirect to={storedRedirect.relative} />;
      }
      if (shouldShowOnboarding) {
        // TODO This should be triggered, not automatic
        setHasSeenWelcomeOnboarding();
        this.props.openModal("WelcomeOnboarding");
      }
      return <Component {...componentProps} />;
    } else {
      return this.redirect("/user/signin");
    }
  };

  render() {
    const {
      authenticated,
      currentRoute,
      userInfo,
      component: Component,
      skipSSO,
      skipTOS,
      skipRedirect,
      skipAll,
      studentDefaultView,
      enableStudentBanner,
      isNative,
      ...rest
    } = this.props;
    //moved back to render as SimpleRoute was creating a delay and showing old library
    //before redirecting. TODO - possible refactor
    const betaHomeCookie =
      Fraction.Helpers.getCookie("beta_home") === "fraction";
    if (
      Fraction.Environment.env !== "development" &&
      studentDefaultView === "dewey" &&
      enableStudentBanner &&
      !isNative &&
      currentRoute.hash.indexOf("#/activate") === -1 &&
      currentRoute.hash.indexOf("#/books/") === -1 &&
      !betaHomeCookie
    ) {
      Fraction.Helpers.setCookie("beta_home", "dewey");
      homeRedirect();
    } else {
      return <SimpleRoute {...rest} component={this.getComponent} />;
    }
  }
}

const mapRouteStateToProps = (state, props) => {
  const isNative = routerSelectors.isNative(state);
  return {
    authenticated: userSelectors.isAuthenticated(state),
    userInfo: userSelectors.getUser(state),
    brand: brandSelectors.getBrand(state),
    shouldShowOnboarding:
      !isNative &&
      !props.skipOnboarding &&
      brandSelectors.shouldShowOnboarding(state) &&
      ((!storageSelectors.getKey(state, "hasSeenWelcomOnboarding") &&
        brandSelectors.shouldAutoShowOnboarding(state)) ||
        brandSelectors.shouldForceShowOnboarding(state)),
    hasSkippedSSO: storageSelectors.getKey(state, "skipSSO", {
      userScope: true
    }),
    currentRoute: routerSelectors.getCurrentRoute(state),
    isNative,
    storedRedirect: routerSelectors.getRedirectRoute(state),
    studentDefaultView: brandSelectors.getBrandValue(state, "StudentHome.view"),
    enableStudentBanner: brandSelectors.getBrandValue(
      state,
      "StudentHome.enabled"
    )
  };
};

export default connect(mapRouteStateToProps, (dispatch, props) => ({
  setStoredRedirect: value => dispatch(routerActions.setStoredRedirect(value)),
  clearStoredRedirect: () => dispatch(routerActions.clearStoredRedirect()),
  setHasSeenWelcomeOnboarding: () =>
    dispatch(storageActions.setHasSeenWelcomeOnboarding()),
  openModal: (type, props) => dispatch(modalActions.openModal(type, props))
}))(Route);
